module.exports = __webpack_public_path__ + "img/1.e6f4fe30.jpg";